import { Link } from 'react-router-dom'

type ActionItem = {
  id: string
  item?: string
  done?: boolean
}

type EndOfDayViewProps = {
  firstName?: string
  eventSummary: {
    today: Array<{ id: string }>
  } | null
  latestActionItems: ActionItem[] | null
  clientTotals: {
    newThisWeek: number
  } | null
}

const EndOfDayView = ({ firstName, eventSummary, latestActionItems, clientTotals }: EndOfDayViewProps) => {
  return (
    <>
      <div className="hero-card-adaptive end-of-day">
        <div className="hero-content">
          <h1 className="hero-title">Nice work today, {firstName || 'there'} 💪</h1>
          <p className="hero-subtitle">
            You completed {eventSummary?.today.length || 0} calls and moved your projects forward.
          </p>
          <div className="hero-actions">
            {/* <button type="button" className="hero-btn primary">Plan Tomorrow</button> */}
            <Link to="/call-notes?filter=Today" className="hero-btn secondary">View Full Recap</Link>
          </div>
        </div>
      </div>

      <div className="home-section">
        <p className="eyebrow">Today's Performance</p>
        <div className="home-panel">
          <div className="home-kpi-grid">
            <div className="home-kpi-card">
              <span className="home-kpi-label">Calls Done</span>
              <span className="home-kpi-value gradient">{eventSummary?.today.length || 0}</span>
            </div>
            <div className="home-kpi-card">
              <span className="home-kpi-label">Tasks Finished</span>
              <span className="home-kpi-value accent">{latestActionItems?.filter(i => i.done).length || 5}</span>
            </div>
            <div className="home-kpi-card">
              <span className="home-kpi-label">New Contacts</span>
              <span className="home-kpi-value">{clientTotals?.newThisWeek || 0}</span>
            </div>
          </div>
        </div>
      </div>

      <div className="home-section">
        <p className="eyebrow">Progress & Planning</p>
        <div className="home-grid-adaptive">
          <div className="home-panel">
            <h2 className="home-highlight-title" style={{ marginBottom: 16 }}>✓ Completed Today</h2>
            <div className="home-action-items-list" style={{ gridTemplateColumns: '1fr' }}>
              <div className="home-action-item" style={{ cursor: 'default' }}>
                <div className="home-action-item-text">
                  <strong>All calls captured by Bev</strong>
                  <p className="muted" style={{ margin: '4px 0 0', fontSize: '13px' }}>Notes and CRM updates are live</p>
                </div>
              </div>
            </div>
          </div>

          <div className="home-panel">
            <h2 className="home-highlight-title" style={{ marginBottom: 16 }}>📅 Tomorrow Preview</h2>
            <div className="home-action-items-list" style={{ gridTemplateColumns: '1fr' }}>
              <div className="home-action-item">
                <div className="home-action-item-text">
                  <strong>2 meetings scheduled</strong>
                  <p className="muted" style={{ margin: '4px 0 0', fontSize: '13px' }}>Starting tomorrow morning</p>
                </div>
                <span className="adaptive-item-badge needs-review">Prep Needed</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default EndOfDayView
